import { ChevronRight, Building2, Award } from "lucide-react";
import { use, useEffect, useState } from "react";
import MainPage from "./MainPage";
import DynamicClassView from "./DinamikClass";
import api from "../utils/api";
import { useDispatch } from "react-redux";
import { selectClassValue } from "../redux/slice/SelectClassSlice";
import { activeComponentValue } from "../redux/slice/ActiveComponentSlice";

function TeacherPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  // Öğretmen bilgileri
  const TeacherName = JSON.parse(localStorage.getItem("postUser"));
  const teacher_name = TeacherName.username;
  const teacher_id = TeacherName._id;
  const dispatch = useDispatch();

  useEffect(() => {
    const getClass = async () => {
      try {
        const res = await api.get("getClassesForTeacher");
        if (res.status === 200) {
          // console.log(res.data.classes, "öğretmen ait tüm classlar");
          setClasses(res.data.classes);
        }
      } catch (error) {
        console.error("Kullanıcı sınıf bilgi bir sorun oluştu", error);
      }
    };
    getClass();
  }, [activeTab]);

  // Tab değiştiği zaman sınıf ID'sini kontrol et
  useEffect(() => {
    if (typeof activeTab === "string" && activeTab.length === 24) {
      setSelectedClassId(activeTab);
    } else {
      setSelectedClassId(null);
    }
  }, [activeTab]);

  // İçerik render fonksiyonu
  const renderContent = () => {
    switch (activeTab) {
      case 0:
        return <MainPage classesvalue={classes || null} />;
      default:
        if (selectedClassId) {
          return <DynamicClassView />;
        }
    }
  };
  //sayfayın sıfır et
  useEffect(() => {
    dispatch(activeComponentValue(0));
  }, []);
  // Sınıf seçildiğinde Redux store'a kaydet
  useEffect(() => {
    if (activeTab === 0 || activeTab === 1 || activeTab === 2) return;

    const selectedClass = classes.find(
      (classroom) => classroom._id === activeTab,
    );

    // console.log(selectedClass, "seçilen sınıf");

    if (selectedClass) {
      // Redux store'a seçilen sınıfı kaydet
      dispatch(selectClassValue(selectedClass));
    }
  }, [activeTab, classes, dispatch]);

  // Sınıf renk paletleri
  const colorPalettes = [
    "from-rose-400 to-pink-500",
    "from-violet-400 to-purple-500",
    "from-amber-400 to-orange-500",
    "from-blue-400 to-indigo-500",
    "from-green-400 to-emerald-500",
    "from-cyan-400 to-teal-500",
    "from-purple-400 to-pink-500",
    "from-yellow-400 to-orange-500",
  ];

  // Toplam öğrenci sayısını hesapla
  // const totalStudents = classes.reduce((total, classroom) => {
  //   return total + (classroom.students?.length || 0);
  // }, 0);

  return (
    <div className="min-h-screen  ">
      <div className="max-w-8xl mx-auto grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Sol Panel - Öğretmen Profili */}
        <div className="xl:col-span-1 space-y-6">
          {/* Profil Kartı */}
          <div className="bg-white rounded-2xl shadow-xl p-4 border border-gray-100 flex flex-row items-center xl:flex-col gap-2 overflow-auto">
            <div className="flex justify-center items-center   min-w-58  gap-4 p-2 bg-gray-100  rounded-2xl  ">
              <div
                className=" w-16 h-16 bg-purple-500 rounded-full 
                flex items-center justify-center text-white text-lg xl:text-xl font-bold shadow-lg cursor-pointer 
                hover:scale-105 transition-transform "
                onClick={() => setActiveTab(0)}
              >
                {teacher_name.charAt(0).toUpperCase()}
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">
                  {teacher_name}
                </h2>
              </div>
            </div>

            {/* İstatistikler */}
            <div>
              <h3 className="text-lg font-semibold text-gray-700 hidden xl:block">
                Sınıflarım
              </h3>
              <hr className="text-purple-500 border hidden xl:block mb-2" />
              {/* lg den önce sınıf görünmü */}
              <div className="flex  gap-2 xl:hidden ">
                {classes?.map((classroom, index) => (
                  <div
                    key={classroom._id}
                    className={`bg-yellow-400 rounded-xl p-4 border 
                    transition-all duration-200  min-w-58 cursor-pointer group hover:shadow-md  ${
                      activeTab === classroom._id
                        ? "border-purple-400 bg-yellow-400"
                        : "border-gray-200"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div
                          className={`w-10 h-10 bg-purple-500 ${
                            colorPalettes[index % colorPalettes.length]
                          } rounded-lg flex items-center justify-center shadow-md`}
                        >
                          <Award className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <p className="font-semibold text-white">
                            {classroom.className}
                          </p>
                          <div className="bg-purple-500 h-0.5"></div>
                          <p className="text-sm text-gray-600">
                            {classroom.students?.length || 0} /{" "}
                            {classroom.maxStudents} öğrenci
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            classroom.isActive ? "bg-purple-500" : "bg-red-500"
                          }`}
                        ></div>

                        <button
                          className={`w-8 h-8 rounded-lg flex items-center justify-center
                           text-white transition-colors group-hover:scale-110 ${
                             activeTab === classroom._id
                               ? "bg-purple-500"
                               : "bg-purple-500 hover:bg-purple-600"
                           }`}
                          onClick={() => setActiveTab(classroom._id)}
                        >
                          <ChevronRight className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {classes.length === 0 && (
                  <div className="text-center py-8 text-gray-500">
                    <Building2 className="w-12 h-12 mx-auto mb-2 opacity-50" />
                    <p>Henüz sınıf eklenmemiş</p>
                    <button
                      onClick={() => setActiveTab(2)}
                      className="mt-2 text-indigo-600 hover:text-indigo-800 font-medium"
                    >
                      İlk sınıfını ekle
                    </button>
                  </div>
                )}
              </div>
              {/* lg den sonra sınıf Görünümü */}
              <div className="hidden xl:flex flex-col gap-2 ">
                {classes?.map((classroom, index) => (
                  <div
                    key={classroom._id}
                    className={`bg-yellow-400 rounded-xl p-2 border 
                    transition-all duration-200 min-w-58 cursor-pointer group hover:shadow-md  ${
                      activeTab === classroom._id
                        ? "border-purple-400 bg-yellow-400"
                        : "border-gray-200"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div
                          className={`w-10 h-10 bg-purple-500 ${
                            colorPalettes[index % colorPalettes.length]
                          } rounded-lg flex items-center justify-center shadow-md`}
                        >
                          <Award className="w-5 h-5 text-white" />
                        </div>
                        <div>
                          <p className="font-semibold text-white">
                            {classroom.className}
                          </p>
                          <div className="bg-purple-500 h-0.5"></div>
                          <p className="text-sm text-gray-600">
                            {classroom.students?.length || 0} /{" "}
                            {classroom.maxStudents} öğrenci
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <div
                          className={`w-2 h-2 rounded-full ${
                            classroom.isActive ? "bg-purple-500" : "bg-red-500"
                          }`}
                        ></div>

                        <button
                          className={`w-8 h-8 rounded-lg flex items-center justify-center
                           text-white transition-colors group-hover:scale-110 ${
                             activeTab === classroom._id
                               ? "bg-purple-500"
                               : "bg-purple-500 hover:bg-purple-600"
                           }`}
                          onClick={() => setActiveTab(classroom._id)}
                        >
                          <ChevronRight className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
                {classes.length === 0 && (
                  <div className="text-center py-8 text-gray-500">
                    <Building2 className="w-12 h-12 mx-auto mb-2 opacity-50" />
                    <p>Henüz sınıf eklenmemiş</p>
                    <button
                      onClick={() => setActiveTab(2)}
                      className="mt-2 text-indigo-600 hover:text-indigo-800 font-medium"
                    >
                      İlk sınıfını ekle
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Sağ Panel - Ana İçerik */}
        <div className="xl:col-span-3">{renderContent()}</div>
      </div>
    </div>
  );
}

export default TeacherPage;
